var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Icon = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 auto;\n\n    path {\n        fill: #888;\n    }\n\n    rect {\n        fill: none;\n    }\n"], ["\n    margin: 0 auto;\n\n    path {\n        fill: #888;\n    }\n\n    rect {\n        fill: none;\n    }\n"])));
export var ArrowIcon = function () { return (React.createElement(Icon, { viewBox: "0 0 16 16", width: "16px", height: "16px" },
    React.createElement("g", { transform: "translate(-193 -515)" },
        React.createElement("path", { d: "M9,10V2H8v8H5l3.5,4L12,10Z", transform: "translate(210 531) rotate(180)" }),
        React.createElement("rect", { width: "16", height: "16", transform: "translate(193 515)" })))); };
var templateObject_1;
//# sourceMappingURL=ArrowIcon.js.map